var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20711 5.20711L5.29289 4.12132C6.01086 3.40335 6.98464 3 8 3C9.01536 3 9.98914 3.40335 10.7071 4.12132L11.7929 5.20711L13.2071 3.79289L12.1213 2.70711C11.0283 1.61406 9.54579 1 8 1C6.45421 1 4.97172 1.61406 3.87868 2.70711L2.79289 3.79289L1 2L0 3V7L1 8L5 8L6 7L4.20711 5.20711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8L16 9V13L15 14L13.2071 12.2071L12.1213 13.2929C11.0283 14.3859 9.54579 15 8 15C6.45421 15 4.97172 14.3859 3.87868 13.2929L2.79289 12.2071L4.20711 10.7929L5.29289 11.8787C6.01086 12.5966 6.98464 13 8 13C9.01536 13 9.98914 12.5967 10.7071 11.8787L11.7929 10.7929L10 9L11 8L15 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.bde859483bf99a853b337f3233bd914a.svg";
export { ForwardRef as ReactComponent };